// Jump navigation ([data-jump-nav], links to blocks on the page): marks the link of the block in view with
// aria-current and keeps it visible in the sideways-scrolling list on narrow screens.
export function initJumpNav() {
	document.querySelectorAll('[data-jump-nav]').forEach((nav) => {
		const links = [...nav.querySelectorAll('a[href^="#"]')]
		const targets = links.map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1))))
		if (!targets.some(Boolean) || !('IntersectionObserver' in window)) return
		const list = links[0].closest('ul')
		const visible = new Set()
		const update = () => {
			const index = targets.findIndex((target) => visible.has(target))
			links.forEach((link, i) => {
				if (i === index) link.setAttribute('aria-current', 'true')
				else link.removeAttribute('aria-current')
			})
			const current = links[index]
			if (current && list.scrollWidth > list.clientWidth) {
				list.scrollTo({ left: current.parentElement.offsetLeft - list.clientWidth / 2 + current.parentElement.offsetWidth / 2, behavior: 'smooth' })
			}
		}
		// a block counts as in view while it crosses the middle band of the window
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => (entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target)))
			update()
		}, { rootMargin: '-40% 0px -55% 0px' })
		targets.filter(Boolean).forEach((target) => observer.observe(target))
	})
}
